import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const MobileappServices: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
              Moweb is a top mobile app development company creating applications for Android and iOS to help businesses stay ahead of the competition. We specialize in developing user-friendly, visually appealing, and responsive mobile applications to help you reach your target audience. With our expertise, we excel at creating native mobile apps that are intuitive and robust, setting the benchmark for user experience. At Moweb, we prioritize understanding your goals and requirements before creating mobile apps that align with your vision.
              </p>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-9">
            <p className="fs-md text-secondary fw-400 mb-2.5">
            Our comprehensive mobile app development solutions for driving digital transformation include -
            </p>
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                  <KEYBlue text="Get end-to-end development from idea to functional app" />
                  <KEYBlue text="Deliver scalable services for business growth" />
                  <KEYBlue text="Proficient in the latest technologies for cutting-edge apps" />
                  <KEYBlue text="SEO-optimized apps for enhanced visibility" />
                  <KEYBlue text="Cross-platform compatibility to reach a wider audience" />
                  <KEYBlue text="Ongoing support and maintenance for smooth functionality" />
            </div>
           
          </div>
        </div>
      </div>
    </section>
  )
}

export default MobileappServices
